import { AddExpenseCategoryDTO, DeleteExpenseCategoryDTO, GetExpenseCategoryDTO, UpdateExpenseCategoryDTO } from "../../dtos/expenseCategoryDTO";
import axios from "../../utils/axiosConfig";

export const add_expense_category = async (category: AddExpenseCategoryDTO) => { 
    const url= 'api/daily_pharmacy_expense/category_add';
    const {data} = await axios.post(url, category);
    return data;
}

export const get_expense_category = async (pagination?: GetExpenseCategoryDTO & { search?: string }) => {
  try {
    let url = `/api/daily_pharmacy_expense/category_get`;

    const params = new URLSearchParams();

    if (pagination?.page !== undefined && pagination?.limit !== undefined) {
      params.append("page", String(pagination.page));
      params.append("limit", String(pagination.limit));
    }

    if (pagination?.search) {
      params.append("search", pagination.search);
    }

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const { data } = await axios.get(url);
    return data;
  } catch (error: any) {
    console.error("Error in get_expense_category:", error);
    throw error;
  }
};


export const delete_expense_category = async (dto: DeleteExpenseCategoryDTO) => {
    const {data} = await axios.delete(
        `/api/daily_pharmacy_expense/category_delete?exp_category_id=${dto.exp_category_id}`
    );
    return data;
}

export const update_expense_category = async (category_update: UpdateExpenseCategoryDTO) => {
    const url = '/api/daily_pharmacy_expense/category_update';
    const { data } = await axios.put(url, category_update);
    return data;
  };

